import { render, staticRenderFns } from "./NewsIA.vue?vue&type=template&id=f9901cd2&scoped=true"
import script from "./NewsIA.vue?vue&type=script&lang=js"
export * from "./NewsIA.vue?vue&type=script&lang=js"
import style0 from "./NewsIA.vue?vue&type=style&index=0&id=f9901cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9901cd2",
  null
  
)

export default component.exports